import React from 'react'
import { useDispatch, connect } from 'react-redux'
import { useForm } from 'react-hook-form'
import PropTypes from 'prop-types'
import {
  formContainer,
  titleContainer,
  secondaryTitle,
  buttonContainer
} from './styles/RecoverMyPasswordForm.style'

import { Button } from '../shared/styles/Button.style'
import Input from '../shared/Input'
import Spinner from '../shared/Spinner'

import * as validators from '../../utils/validators'
import { resetPassword } from '../../store/passwordRecovery/actions'

const RecoverMyPasswordForm = ({
  onSubmit,
  isSubmitting,
  isSuccess,
  token,
  translation,
  lang
}) => {
  const dispatch = useDispatch()
  const required = lang === 'pt-BR' ? validators.requiredPT : validators.requiredES
  const passwordLength = lang === 'pt-BR' ? validators.passwordLengthPT : validators.passwordLengthES
  const passwordConfirmation = lang === 'pt-BR' ? validators.passwordConfirmationPT : validators.passwordConfirmationES
  const { control, getValues, handleSubmit } = useForm({
    defaultValues: {
      password: '',
      passwordConfirmation: ''
    }
  })

  const submitForm = handleSubmit((values) => {
    if (onSubmit) {
      onSubmit(values)
      return
    }
    dispatch(resetPassword({ data: values, translation, lang, token }))
  })

  return (
    <>
      <form className={formContainer} onSubmit={submitForm}>
        <header className={titleContainer}>
          <h2 className={secondaryTitle}>{translation('recoverPasswordForm')['passwordFormTitle']}</h2>
        </header>

        <div>
          <div>
            <Input
              control={control}
              name='password'
              rules={{ validate: validators.composeValidators(required, passwordLength) }}
              placeholder={translation('recoverPasswordForm')['newPasswordPlaceholder']}
              type='password'
              block
            />
          </div>

          <div>
            <Input
              control={control}
              name='passwordConfirmation'
              rules={{ validate: validators.composeValidators(required, passwordConfirmation(getValues)) }}
              placeholder={translation('recoverPasswordForm')['confirmPasswordPlaceholder']}
              type='password'
              block
            />
          </div>
        </div>

        <div className={buttonContainer}>
          <Button
            type='submit'
            disabled={isSubmitting}
          >
            {isSubmitting && <Spinner size='0.8rem' />}
            {translation('recoverPasswordForm')['changeButton']}
          </Button>
        </div>
      </form >
    </>
  )
}

RecoverMyPasswordForm.propTypes = {
  onSubmit: PropTypes.func,
  translation: PropTypes.func,
  lang: PropTypes.string,
  token: PropTypes.string,
  isSubmitting: PropTypes.bool,
  isSuccess: PropTypes.bool
}

const mapStateToProps = (state) => ({
  isSubmitting: state.passwordRecovery.isSubmitting,
  isSuccess: state.passwordRecovery.isSuccess
})

export default connect(mapStateToProps)(RecoverMyPasswordForm)
